import { render } from "./SummaryFinancingService.vue?vue&type=template&id=1c4627bb&scoped=true&ts=true"
import script from "./SummaryFinancingService.vue?vue&type=script&lang=ts"
export * from "./SummaryFinancingService.vue?vue&type=script&lang=ts"

import "./SummaryFinancingService.vue?vue&type=style&index=0&id=1c4627bb&lang=scss&scoped=true"

import exportComponent from "/builds/weleaf/twd-origination-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c4627bb"]])

export default __exports__
import QExpansionItem from 'quasar/src/components/expansion-item/QExpansionItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QExpansionItem,QItemSection});
